// extracted by mini-css-extract-plugin
export var addressItem = "carnet-adresse-module--address-item--6a74a";
export var addressItemAddress = "carnet-adresse-module--address-item-address--85cc0";
export var addressItemContacts = "carnet-adresse-module--address-item-contacts--09252";
export var addressItemMail = "carnet-adresse-module--address-item-mail--e840a";
export var addressItemMailMobile = "carnet-adresse-module--address-item-mail-mobile--144ca";
export var addressItemName = "carnet-adresse-module--address-item-name--41dda";
export var addressItemTel = "carnet-adresse-module--address-item-tel--4cb7a";
export var addressItemTitle = "carnet-adresse-module--address-item-title--1b0fb";
export var addressItemTooltip = "carnet-adresse-module--address-item-tooltip--a1ace";
export var addressItemTooltipMobile = "carnet-adresse-module--address-item-tooltip-mobile--b9e2b";
export var addressMore = "carnet-adresse-module--address-more--e159a";
export var addressesContainer = "carnet-adresse-module--addresses-container--8ed28";
export var addressesDescription = "carnet-adresse-module--addresses-description--1f7c7";
export var allAddresses = "carnet-adresse-module--all-addresses--5dbaa";
export var editButtonTitle = "carnet-adresse-module--edit-button-title--1ae15";
export var hiddenInfoBulle = "carnet-adresse-module--hidden-info-bulle--5e65f";
export var listAddressesContainer = "carnet-adresse-module--list-addresses-container--b67e7";
export var listAddressesTitle = "carnet-adresse-module--list-addresses-title--74554";
export var pasteButton = "carnet-adresse-module--paste-button--0c5bb";
export var pasteButtonImg = "carnet-adresse-module--paste-button-img--9b95b";